<section class="products-section">
  <span class="visually-hidden"
        #products></span>
  <div class="width-wrapper">
      <h2 class="products-title">Продукты</h2>
      <div class="products-wrapper">

        <div class="product-item">
          <!--suppress CheckImageSize -->
          <img class="img-podborki"
               src="../../../assets/img/bronir-system.png"
               alt="Система бронирования отелей для туроператоров"
               width="710"
               height="386">
          <div class="product-text">
            <span>ТОП.B2B</span>
            <a class="follow-link-about"
               #aboutSystemBronir
               (click)="openModal()"
               href="#">Описание</a>
            <p class="item-text">Платформа для B2B-продаж и дистрибуции отелей</p>
            <div class="modal-wrap">
              <app-modal-window *ngIf="isModalShowed"
                                (closeModal)="modalCloseHandler()"></app-modal-window>
            </div>
          </div>
        </div>

        <div class="product-item">
          <!--suppress CheckImageSize -->
          <img class="img-TSP"
               src="../../../assets/img/bookhotelspro.png"
               alt="BookHotels.PRO"
               width="710"
               height="386">
          <div class="product-text">
            <span>BookHotels.PRO</span>
            <a class="follow-link" href="https://bookhotels.pro">Перейти</a>
            <p class="item-text">Сервис бронирования отелей для турагентов</p>
          </div>
        </div>
      </div>
    <div class="products-wrapper">

        <div class="product-item">
          <!--suppress CheckImageSize -->
          <img class="img-TSP"
               src="../../../assets/img/travelsyspro.png"
               alt="TravelSys.Pro"
               width="710"
               height="386">
          <div class="product-text">
            <span>TravelSys.Pro</span>
            <a class="follow-link" href="#">Перейти</a>
            <p class="item-text">Разрабатываемая система</p>
          </div>
        </div>

        <div class="product-item">
          <!--suppress CheckImageSize -->
          <img class="img-podborki"
               src="../../../assets/img/moipodborki.png"
               alt="Мои Подборки"
               width="710"
               height="386">
          <div class="product-text">
            <span>МоиПодборки</span>
            <a class="follow-link" href="https://xn--90aflcjiobcgp.xn--p1ai/">Перейти</a>
            <p class="item-text">Пилотная версия</p>
          </div>
        </div>

      </div>

  </div>
</section>
